import React from "react";
import { NavLink } from "react-router-dom";
import logo_gx from "assets/gx.png";
import "./notFound.css";

const NotFound = () => {
  return (
    <>
      <div className="message404">
        <h2>404</h2>
        <h1>Page Not Found</h1>
        <NavLink to="/" className="neonBtn404">
          Home
        </NavLink>
      </div>
      <div className="img404">
        <img src={logo_gx} alt="geekonix" />
      </div>
    </>
  );
};

export default NotFound;
